<form class="example-form">
  <mat-form-field class="full-width">

      <input    matInput
                #placeInput
                [placeholder]       =   "'autocomplete.name.place' | translate"
                [formControl]       =   "placeCtrl"
                [matAutocomplete]   =   "auto"
                (focus)             =   "focused($event)"
                (click)             =   "placeTrigger.openPanel()"
                required>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selected($event)">
          <mat-option *ngFor="let place of filteredPlaces | async" [value]="place">
              {{place.name}}
          </mat-option>
      </mat-autocomplete>
      
  </mat-form-field>
</form>